import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const EyeSlashIcon = ({ color = '#FFFFFF', size = 48, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 18 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 10.937c-2.133 0-3.86-1.605-4.02-3.64L2.03 5.082a9.096 9.096 0 0 0-1.032 1.52.863.863 0 0 0 0 .798C2.523 10.292 5.543 12.25 9 12.25a8.97 8.97 0 0 0 2.19-.285l-1.459-1.098c-.24.045-.486.07-.731.071zm8.826 1.59-3.11-2.337a9.106 9.106 0 0 0 2.286-2.791.863.863 0 0 0 0-.798C15.477 3.708 12.457 1.75 9 1.75a8.863 8.863 0 0 0-4.143 1.03L1.279.092A.46.46 0 0 0 .647.17L.095.86a.43.43 0 0 0 .079.614L16.72 13.908a.46.46 0 0 0 .632-.077l.552-.691a.43.43 0 0 0-.079-.614zM12.66 8.642l-1.105-.83c.093-.262.142-.536.146-.813.011-.822-.38-1.6-1.052-2.097a2.726 2.726 0 0 0-2.36-.424c.17.223.261.493.262.771a1.243 1.243 0 0 1-.043.273l-2.07-1.555A4.072 4.072 0 0 1 9 3.063c1.074-.001 2.105.414 2.864 1.152A3.88 3.88 0 0 1 13.05 7c0 .591-.149 1.143-.391 1.644z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

EyeSlashIcon.propTypes = propTypes;

export default EyeSlashIcon;
